import {TextField, withStyles, WithStyles, FormHelperText} from '@material-ui/core'
import {ReactElement} from 'react'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import compose from 'lodash/flowRight'

import {styles} from '../styles'
import messages from '../../../../../../assets/messages'

type CompanyFieldsProps = {
  values: Record<string, string>
  errors: Record<string, boolean>
  errorsKeys: Record<string, string>
  onChange: (fieldName: string, value: string) => void
} & WithNamespaces &
  WithStyles

function CompanyFieldsBase(props: CompanyFieldsProps): ReactElement {
  const {
    t,
    classes,
    errors,
    errorsKeys,
    values: {companyName, companyRegistrationNumber},
    onChange,
  } = props

  return (
    <div className={classes.fieldsColumn}>
      <div className={classes.field}>
        <TextField
          required
          id="companyName"
          name="companyName"
          label={t(messages.companyName.i18nKey, messages.companyName.defaults)}
          fullWidth
          autoComplete="companyName"
          error={errors.companyName}
          value={companyName}
          onChange={(e) => onChange('companyName', e.target.value)}
        />
        {companyName && errors.companyName && messages[errorsKeys.companyName] ? (
          <FormHelperText className={classes.errorMessage}>
            <Trans {...messages[errorsKeys.companyName]} />
          </FormHelperText>
        ) : null}
      </div>
      <div className={classes.field}>
        <TextField
          required
          id="companyRegistrationNumber"
          name="companyRegistrationNumber"
          label={t(messages.companyRegistrationNumber.i18nKey, messages.companyRegistrationNumber.defaults)}
          fullWidth
          autoComplete="companyRegistrationNumber"
          value={companyRegistrationNumber}
          error={errors.companyRegistrationNumber}
          onChange={(e) => onChange('companyRegistrationNumber', e.target.value)}
        />
        {companyRegistrationNumber && errors.companyRegistrationNumber && messages[errorsKeys.companyRegistrationNumber] ? (
          <FormHelperText className={classes.errorMessage}>
            <Trans {...messages[errorsKeys.companyRegistrationNumber]} />
          </FormHelperText>
        ) : null}
      </div>
    </div>
  )
}

export const CompanyFields = compose(withStyles(styles), withNamespaces())(CompanyFieldsBase)
